import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";

const metricProcessName = "SCC_PACKAGE_SEARCH";
export async function getContainerHistoryForAssociate(associateLoginId, pageSize, pageToken = null, fromEpochMilli = null, toEpochMilli = null) {
    const requestBody = {
        "associateLoginId": associateLoginId,
        "pageSize": pageSize,
        "pageToken": pageToken,
        "startTime": fromEpochMilli,
        "endTime": toEpochMilli
    }
    const startTime = Date.now();

    const request = {
        resourcePath: "/os/getContainerHistoryForAssociate",
        httpMethod: "post",
        processName: "oculus",
        requestBody: requestBody
    }

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getContainerHistoryForAssociate", true);
            return response.data;
        } else {
            logOperationalMetric(startTime, metricProcessName, "getContainerHistoryForAssociate", false);
            return {
                containerRecordList: [],
                nextPageToken: null
            };
        }
    } catch (error) {
        return {
            containerRecordList: [],
            nextPageToken: null
        }
    }

}


// WEBPACK FOOTER //
// ./src/commons/api/GetContainerHistoryForAssociateResults.js